import {createContext} from 'react'

const CatServiciosContext = createContext()

export default CatServiciosContext